var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08057 13.1718H0V22.68H7.08057V13.1718Z",
    fill: "#6189D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9406 10.7287H16.86V22.68H23.9406V10.7287Z",
    fill: "#6189D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5121 7.18329H8.42944V22.68H15.5121V7.18329Z",
    fill: "#6189D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4547 3.52484L21.4574 5.55901L23.7032 5.88568L22.08 7.46886L22.4621 9.70544L20.4547 8.64931L18.4473 9.70544L18.8294 7.46886L17.2062 5.88568L19.4499 5.55896L20.4547 3.52484Z",
    fill: "#6189D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0088 0L13.0125 2.03521L15.2583 2.36194L13.6351 3.94612L14.0183 6.1806L12.0098 5.12551L10.0013 6.1806L10.3835 3.94612L8.76025 2.36194L11.005 2.03521L12.0088 0Z",
    fill: "#6189D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41699 5.89703L4.41969 7.93225L6.66551 8.25997L5.04332 9.8421L5.42548 12.0776L3.41699 11.0225L1.4085 12.0787L1.79171 9.84315L0.168518 8.26097L2.41329 7.93325L3.41699 5.89703Z",
    fill: "#6189D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardLight);
export default __webpack_public_path__ + "static/media/LeaderboardLight.08ab9113fe4ccba22b65c0467adfb18c.svg";
export { ForwardRef as ReactComponent };